module.exports = __webpack_public_path__ + "img/wf.f0474a3d.svg";